import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalContent: ({ colors, spacing }) => css`
    padding: ${spacing.xs} 0;

    @media (max-width: 639px) {
      max-height: 220px;
      overflow: auto;
    }

    p {
      color: ${colors.neutral[500]};

      + p {
        margin-top: ${spacing.xs};
      }

      a {
        color: ${colors.brand.primary[300]};
      }
    }
  `,
})

export default useStyles
